var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplemusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78917 13.7378V6.63169C4.78917 6.36522 4.93721 6.20237 5.2333 6.14315L11.3623 4.89958C11.688 4.84037 11.8657 4.98841 11.8953 5.34371V10.7621C11.8953 11.2062 11.2291 11.5023 9.89668 11.6504C7.36513 12.0501 7.76485 16.3138 11.2291 15.159C12.5615 14.6705 12.7835 13.3825 12.7835 12.0945V1.70184C12.7835 1.70184 12.7835 0.813574 12.0285 1.03564L4.47827 2.5901C4.47827 2.5901 3.9009 2.67893 3.9009 3.38954V12.4054C3.9009 12.8495 3.23471 13.1456 1.90231 13.2937C-0.629237 13.6934 -0.229518 17.957 3.23471 16.8023C4.5671 16.3138 4.78917 15.0258 4.78917 13.7378Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplemusic);
export default __webpack_public_path__ + "static/media/applemusic.c63acf2bcf2c8a869f6e3f03ab34b59d.svg";
export { ForwardRef as ReactComponent };